import { request } from './client'

/* ============================================================================
   **CQ-26 — THE FIVE THINGS THAT RAISE WORK.** Sprint 83.

   The client's answer: *"All five, each independently switchable on or off with its own
   configurable rules."*

   Three were built and had no switch. The deep clean was **configured and inert** — every
   room has carried a frequency since Sprint 48 and nothing ever read it — and the vacant
   refresh did not exist.
   ========================================================================= */

export type WorkTriggerCode =
  | 'GUEST_CHECKOUT'
  | 'STAYOVER_SERVICE'
  | 'SCHEDULED_DEEP_CLEAN'
  | 'VACANT_ROOM_REFRESH'
  | 'ON_REQUEST'

export interface WorkTriggerRow {
  code: WorkTriggerCode
  isActive: boolean
  /** Null for the four whose rule is not a number of days. */
  intervalDays: number | null
  /** **SENT, NOT INFERRED.** The day a second trigger needs a number, the screen grows
   *  the box without being changed — and a client deciding for itself which codes have
   *  rules would be a second copy of the server's own list. */
  needsIntervalDays: boolean
  /** The hotel's own date on which it last became active, and the anchor for a room that
   *  has never had the work. The screen prints it: for the deep clean it is the difference
   *  between "nothing is happening" and "the first round falls in December". */
  activeFromLocalDate: string | null
}

export const fetchWorkTriggers = (
  propertyId: string, options: { signal?: AbortSignal } = {}) =>
  request<WorkTriggerRow[]>(
    `/properties/${propertyId}/work-triggers`,
    options.signal ? { signal: options.signal } : {})

/** The switch and its rule are ONE call: switching on a trigger without its rule would
 *  switch on a trigger that cannot fire. */
export const saveWorkTrigger = (
  propertyId: string, code: WorkTriggerCode,
  body: { isActive: boolean; intervalDays: number | null }) =>
  request<WorkTriggerRow[]>(
    `/properties/${propertyId}/work-triggers/${code}`,
    { method: 'PUT', body })
